import { useTranslate } from 'module/hooks/use-translation';
import { UiFieldType } from '../fields/types';

export interface SignalFieldTypeOption {
  label: string;
  value: UiFieldType;
}

export const fieldTypeAsOptions = (
  translate: ReturnType<typeof useTranslate>,
): SignalFieldTypeOption[] =>
  Object.values(UiFieldType).map((type) => ({
    value: type,
    label: translate(`fields.label.${type.toLowerCase()}` as any),
  }));
